(() => {
  const init = () => {
    document.querySelectorAll('[data-qf-nav]').forEach((menu) => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const trigger = menu.querySelector('summary');
      const close = (restore) => {
        menu.open = false;
        if (restore) trigger.focus();
      };
      menu.addEventListener('click', (event) => {
        if (event.target.closest('a')) close(false);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.open) { event.preventDefault(); close(true); }
      });
      document.addEventListener('click', (event) => {
        if (menu.open && !menu.contains(event.target)) close(false);
      });
      menu.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (menu.open && !menu.contains(document.activeElement)) close(false);
        });
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
